export enum InstanceTenancyAWS {
  SHARED = "Shared",
  DEDICATED = "Dedicated",
  HOST = "Host",
}

